import React from 'react';

// Higher-Order Component
const withClientNumber = <P extends object>(
  WrappedComponent: React.ComponentType<P>
) => {
  const HOC: React.FC<P> = (props) => {
    const params = new URLSearchParams(window.location.search);
    const client_number = params.get('client_number');


    return <WrappedComponent {...props} clientNumber={client_number} />;
  };

  return HOC;
};

export default withClientNumber;